"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapHubspotConsentToGoogleAdsPreferences = exports.mapHubspotConsentToSegmentPreferences = exports.mapToConsentStatus = void 0;
const google_ads_consents_1 = require("./google-ads-consents");
// Map boolean consent values to 'granted' | 'denied'
const mapToConsentStatus = (hasGrantedConsent) => hasGrantedConsent ? google_ads_consents_1.ConsentState.Granted : google_ads_consents_1.ConsentState.Denied;
exports.mapToConsentStatus = mapToConsentStatus;
/**
 * Maps the consent preferences from Hubspot to our Segment consent preferences
 */
const mapHubspotConsentToSegmentPreferences = ({ categories: { advertisement, analytics, functionality, necessary }, }) => ({
    necessary,
    performance: functionality,
    functional: functionality,
    advertising: advertisement,
    marketing: advertisement,
    marketingAndAnalytics: advertisement && analytics,
});
exports.mapHubspotConsentToSegmentPreferences = mapHubspotConsentToSegmentPreferences;
/**
 * Maps the consent preferences from Hubspot to our Google Ads consent preferences
 *
 *  Read more here:
 *  https://developers.hubspot.com/beta-docs/reference/api/analytics-and-events/cookie-banner/cookie-banner-api
 */
const mapHubspotConsentToGoogleAdsPreferences = ({ categories: { advertisement, analytics }, }) => ({
    // Consent for personalized advertising
    ad_personalization: (0, exports.mapToConsentStatus)(advertisement),
    // Consent for sending user data related to advertising
    ad_user_data: (0, exports.mapToConsentStatus)(advertisement),
    // Enables storage related to advertising
    ad_storage: (0, exports.mapToConsentStatus)(advertisement),
    // Enables storage related to analytics (e.g., visit duration)
    analytics_storage: (0, exports.mapToConsentStatus)(analytics),
});
exports.mapHubspotConsentToGoogleAdsPreferences = mapHubspotConsentToGoogleAdsPreferences;
